const Header = (props) => {
  const { handleClick } = props;
  return (
    <header className="header">
      <div className="header__text-box">
        <h1 className="heading-primary">
          <a
            href="https://twitter.com/hashtag/ReactDayIN"
            target="_blank"
            rel="noopener noreferrer"
            className="heading-primary--main"
          >
            #ReactDayIN 2021
          </a>
          <span className="heading-primary--sub">Talks - Slides</span>
          <button className="btn" onClick={handleClick}>
            Check It Out
          </button>
        </h1>
      </div>
    </header>
  );
};

export default Header;
